import BuildDetailModal from './BuildDetailModal';
export default BuildDetailModal;
